import { stringify } from 'qs';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { stripLastPathSegment } from '../../../../helpers/paths';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { icons, IconText } from '../../../generic/Icon';
import RouterLink from '../../../generic/Link/RouterLink';
import type { ProjectScope } from '../../../../../shared/issuesV2';

/**
 * Returns the number of path segments to strip from the current pathname.
 * If we're in comparison mode but haven't selected a revision to compare to yet, then we need to strip only 1 segment.
 * If we have already selected a revision to compare to, then we need to strip 2 segments.
 */
const getPathSegmentToStripCount = (scope: ProjectScope) =>
  scope.compareTo ? 2 : 1;

/**
 * StopComparing is a link which will bring the user back to the issues page.
 * It checks the Redux store to check if there are filters which it can
 * stringify so that the user is linking back with the same filters applied.
 */
const StopComparing: VoidFunctionComponent = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);

  // Even though all of the filters still exist in state, we need to add them to the URL so that they
  // don't get lost when navigating back to the issues page.
  const filters = useSelector(
    IssuesV2Store.selectors.getHydrateStateQuery,
  );
  const basePath = stripLastPathSegment(window.location.pathname, getPathSegmentToStripCount(scope as ProjectScope));
  const backToURL = `${basePath}?${stringify(filters)}`;

  return (
    <div>
      <RouterLink to={backToURL}>
        <IconText
          icon={icons.xCircle}
          text="Stop comparing"
        />
      </RouterLink>
    </div>
  );
};

export default StopComparing;
